interface StarsProps {
  className?: string;
  size?: string;
  /** When true, stars fill one after another once `start` becomes true. */
  animated?: boolean;
  start?: boolean;
}

export default function Stars({
  className = '',
  size = 'text-base',
  animated = false,
  start = false,
}: StarsProps) {
  return (
    <span
      className={`inline-flex items-center gap-0.5 ${size} ${className}`}
      aria-label="5 von 5 Sternen"
      role="img"
    >
      {[0, 1, 2, 3, 4].map((i) => {
        const active = animated ? start : true;
        return (
          <i
            key={i}
            className={`ri-star-fill transition-all duration-500 ${
              active ? 'text-[#FBBC05]' : 'text-background-400/60'
            } ${animated && start ? 'scale-110' : 'scale-100'}`}
            style={animated ? { transitionDelay: `${i * 160}ms` } : undefined}
          />
        );
      })}
    </span>
  );
}